<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='邮箱列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="10" style="margin-bottom: 10px;">
         <el-select v-model="param.status" placeholder="请选择状态" filterable @change="search">
            <el-option label="请选择状态" :value="0"></el-option>
            <el-option v-for="item in statusList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>&nbsp;
          <el-select v-model="param.labels" multiple filterable placeholder="请选择标签" @change="search" style="width: 300px;">
            <el-option label="请选择标签" :value="0"></el-option>
            <el-option v-for="item in labelList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="5">
          <el-input placeholder="请输入邮箱" v-model="param.keyword" clearable @clear="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="6.5">
          <el-button type="primary" @click="exportCVS">导出CVS</el-button>&nbsp;
          <el-button type="primary" @click="showMultiLabelDialog">批量添加标签</el-button>&nbsp;
          <el-button type="primary" @click="showMailAddDialog(0)">添加邮箱</el-button>
        </el-col>
        <el-col :span="2">
          <el-upload
            action="/proxy/admin/subscribe/import_from_csv"
            :on-success="handleSuccess"
            name="file"
            :file-list="fileList"
            :headers="header"
          >
            <el-button type="primary">导入邮箱</el-button>
          </el-upload>
        </el-col>
      </el-row>
      <el-table :data="list" @selection-change="handleSelectionChange" @sort-change="handleSortChange" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column type="selection" width="40" align="center"></el-table-column>
        <el-table-column prop="id" label="ID" align="center" width="150px"></el-table-column>
        <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
        <el-table-column prop="send_sub_times" label="发送次数" align="center"></el-table-column>
        <el-table-column prop="send_post_num" label="发送文章" align="center" sortable="custom"></el-table-column>
        <el-table-column prop="read_post_num" label="已读文章" align="center" sortable="custom"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{scope.row.status | getStatusTitle(statusList)}}
          </template>
        </el-table-column>
        <el-table-column label="订阅时间" align="center">
          <template slot-scope="scope" v-if="scope.row.status === 20">
            {{scope.row.update_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="标签" align="center">
          <template slot-scope="scope">
            <el-tag size="small" v-for="item in scope.row.labels" :key="item.id" style="margin-right: 5px;">{{item.title}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="300px">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="showLabelDialog(scope.row.id, scope.row.labels)">添加标签</el-button>
            <el-button type="warning" icon="el-icon-edit" size="mini" @click="showMailAddDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteMail(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
       :current-page="param.page"
       :page-sizes="[10, 20, 30, 40, 50]"
       :page-size="param.count"
       layout="total, sizes, prev, pager, next, jumper"
       :total="total">
     </el-pagination>
    </el-card>
    <mail-label :visible="addLabelDialogAvaible"
      :id="currentId"
      :labelList="labelList"
      :labels="currentLabels"
      :isMulti="isMulti"
      @add="addLabel"
      @multiAdd="multiAddLabel"
      @closeDialog="closeLabelDialog">
    </mail-label>
    <mail-add
      :visible="addMailDialogAvaible"
      :id="currentId"
      @add="addMail"
      @update="updateMail"
      @closeDialog="closeMailAddDialog">
    </mail-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import MailLabel from './MailLabel.vue'
import MailAdd from './MailAdd.vue'
export default {
  name: 'subscribe_mail_list',
  components: {
    'bread-crumb': BreadCrumb,
    'mail-label': MailLabel,
    'mail-add': MailAdd
  },
  created () {
    this.getList()
    this.getLabelList()
    this.header = {
      token: window.sessionStorage.getItem('token')
    }
  },
  data () {
    return {
      list: [],
      total: 0,
      pageTotal: 1,
      param: {
        keyword: '',
        status: 0,
        labels: [],
        sort_by: '',
        sort_order: '',
        page: 1,
        count: 10
      },
      fileList: [],
      header: {},
      statusList: [
        { id: 10, title: '未订阅' },
        { id: 20, title: '订阅' },
        { id: 40, title: '拒绝' }
      ],
      ids: [],
      currentId: 0,
      isMulti: false,
      currentLabels: [],
      labelList: [],
      addLabelDialogAvaible: false,
      addMailDialogAvaible: false
    }
  },
  filters: {
    getStatusTitle (id, statusList) {
      for (var i = 0; i < statusList.length; i++) {
        if (statusList[i].id === id) {
          return statusList[i].title
        }
      }
      return ''
    }
  },
  methods: {
    search () {
      this.param.page = 1
      this.getList()
    },
    handleSelectionChange (val) {
      this.ids = []
      val.forEach(row => {
        this.ids.push(row.id)
      })
    },
    async getList () {
      const res = await this.$http.get('/admin/subscribe/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    async getLabelList () {
      const res = await this.$http.get('/admin/label/select_list')
      if (res.code === 0) {
        this.labelList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    showLabelDialog (id, labels) {
      this.currentId = id
      this.currentLabels = []
      for (const item of labels) {
        this.currentLabels.push(item.id)
      }
      this.addLabelDialogAvaible = true
    },
    showMultiLabelDialog () {
      this.isMulti = true
      this.addLabelDialogAvaible = true
    },
    closeLabelDialog () {
      this.currentId = 0
      this.isMulti = false
      this.currentLabels = []
      this.addLabelDialogAvaible = false
    },
    async addLabel (data) {
      const res = await this.$http.post('/admin/subscribe/label_update', data)
      if (res.code === 0) {
        this.closeLabelDialog()
        this.getList()
        this.getLabelList()
        this.$message.success('添加成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    async multiAddLabel (data) {
      const res = await this.$http.post('/admin/subscribe/multi_add_label', {
        labels: data.labels,
        ids: this.ids,
        status: this.param.status,
        keyword: this.param.keyword
      })
      if (res.code === 0) {
        this.closeLabelDialog()
        this.getList()
        this.getLabelList()
        this.$message.success('添加成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    showMailAddDialog (id) {
      this.currentId = id
      this.addMailDialogAvaible = true
    },
    closeMailAddDialog () {
      this.currentId = 0
      this.addMailDialogAvaible = false
    },
    async addMail (data) {
      const res = await this.$http.post('/admin/subscribe/add', data)
      if (res.code === 0) {
        this.closeMailAddDialog()
        this.getList()
        this.$message.success('添加成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateMail (id, data) {
      const res = await this.$http.post('/admin/subscribe/update/' + id, data)
      if (res.code === 0) {
        this.closeMailAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    deleteMail (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/subscribe/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    exportCVS () {
      const link = document.createElement('a')
      link.href = '/proxy/admin/subscribe/export_csv?status=' + this.param.status
      link.click()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    handleSortChange ({ prop, order }) {
      this.param.sort_by = prop
      if (order === 'ascending') {
        this.param.sort_order = 'ASC'
      } else {
        this.param.sort_order = 'DESC'
      }
      this.param.page = 1
      this.param.keyword = ''
      this.getList()
    },
    handleSuccess () {
      this.fileList = []
      this.$message.success('导入成功')
    }
  }
}
</script>

<style scoped>
</style>
